import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MasterPage from './components/masterpage/MasterPage';
import RecipeDetailPage from './pages/RecipeDetail';
import NewRecipePage from './pages/NewRecipe';
import HomePage from './pages/HomePage';
import PrincipalRecipesPage from './pages/PrincipalRecipes';
import Login from './components/Login';
import Logout from './pages/Logout';
import ProfilePage from './pages/Profile';
import SearchPage from './pages/Search';
import ErrorPage from './pages/Error';
import WhatToEatTodayPage from './pages/WhatToEatToday';


// Crear un tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#FFA500', // Color principal (naranja)
      contrastText: '#FFFFFF'
    },
  },
});

function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<MasterPage />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/me" element={<ProfilePage />} />
              <Route path="/me/recipes" element={
                <ProtectedRoute>
                  <PrincipalRecipesPage />
                </ProtectedRoute>
              } />
              <Route path="/recipes/:id" element={<RecipeDetailPage />} />
              <Route path="/recipes/suggestion" element={<WhatToEatTodayPage />} /> 
              <Route path="/recipes/new" element={
                <ProtectedRoute>
                  <NewRecipePage />
                </ProtectedRoute>
              } />
              <Route path="/search" element={<SearchPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;